import { NestedLocation } from '../../types/nestedLocations';
import { Branch } from './icons/Branch';
import { DistributionCenter } from './icons/DistributionCenter';
import { Enterprise } from './icons/Enterprise';
import { Office } from './icons/Office';
import { Other } from './icons/Other';
import { Plant } from './icons/Plant';
import { ProductionLine } from './icons/ProductionLine';
import { Warehouse } from './icons/Warehouse';

interface LocationIconProps {
  placeType: NestedLocation['place_type_id'];
}

export function LocationIcon({ placeType }: LocationIconProps) {
  switch (placeType) {
    case 'plant':
      return <Plant />;
    case 'distribution_center':
      return <DistributionCenter />;
    case 'warehouse':
      return <Warehouse />;
    case 'office':
      return <Office />;
    case 'branch':
      return <Branch />;
    case 'production_line':
      return <ProductionLine />;
    case 'enterprise':
      return <Enterprise />;
    default:
      return <Other />;
  }
}
